import React, { useEffect } from 'react';
import FacilityPage from '../components/FacilityPage';

const Restaurant: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Restaurant"
      description="Welcome to our restaurant, where culinary artistry meets elegant design. Our restaurant offers an exceptional dining experience with a carefully curated menu featuring global cuisines. From authentic Indian delicacies to international favorites, every dish is prepared with the finest ingredients and utmost care."
      features={[
        "Global cuisine with authentic flavors",
        "Fresh ingredients sourced daily",
        "Professional chefs with international experience",
        "Elegant dining atmosphere",
        "Perfect for family dinners and romantic dates",
        "Extensive vegetarian and non-vegetarian options"
      ]}
      images={["/images/about1.jpg", "/images/about2.jpg"]}
    />
  );
};

export default Restaurant;